'use client'

import Image from 'next/image'
import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

import { cn } from '@src/utils/tailwind'

type FieldCaptionProps = ComponentProps<'div'> & {
  isInvalid?: boolean
  isSuccess?: boolean
  captionText?: string | TrustedHTML
  disabled?: boolean
  ['data-testid']?: string
}

export const FieldCaption = ({
  isInvalid,
  isSuccess,
  captionText,
  disabled,
  className,
  ...rest
}: FieldCaptionProps) => (
  <div
    data-testid={rest['data-testid']}
    className={twMerge(
      cn('mt-1 flex items-start gap-1', {
        'text-bodi-red-error': isInvalid,
        'text-bodi-green-success': isSuccess,
        'text-bodi-gray-disabled': disabled,
      }),
      className
    )}
    {...rest}
  >
    {isInvalid && (
      <Image
        className="mt-1"
        width={11}
        height={11}
        src="/images/invalid_icon.svg"
        alt="Invalid icon"
      />
    )}
    {captionText && (
      <p
        className="prose text-body-xs [&_a]:cursor-pointer [&_a]:font-bold"
        dangerouslySetInnerHTML={{ __html: captionText }}
      />
    )}
  </div>
)
